export const BLUE = '#00a7ef';
export const GRAY = '#979797';
